import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

function ScrollToTop({ gamePopupType }) {
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, gamePopupType]);

  return null;
}

export default ScrollToTop;